import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'warehouse';

const warehouseService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  updateWarehouse: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createWarehouse: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteWarehouse: (data, code) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(code)}`,
      data,
    });
  },
  deleteWarehouse: (data, code) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(code)}`,
      data,
    });
  },

  getBins: (whsCode) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/bins/${encodeURIComponent(whsCode)}`,
    });
  },

  saveBins: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/bins`,
      data,
    });
  },

  deleteBin: (binId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/bin/${encodeURIComponent(binId)}`,
    });
  },
};
export default warehouseService;
